module.exports = __webpack_public_path__ + "static/assets/f9e2cae9dedbfd87d881582f84750ab7.svg";